<template>
    <vx-card class="w-11/12 shadow-lg">
        <action-bar class="action-bar">
            <template v-slot:left>
                <h2>Products</h2>
            </template>
            <template v-slot:right>
                <vx-action-icon
                    :icon="'PlusSquareIcon'"
                    :tooltip="'Add Product'"
                    @click="$router.push('/products/new')"
                >
                </vx-action-icon>
            </template>
        </action-bar>

        <vx-server-side-table
            class="px-4"
            ref="servertable"
            v-model="selected"
            :fetchData="$api.product.fetchProducts"
            :columns="columns"
        >
        </vx-server-side-table>
    </vx-card>
</template>

<script>
import ActionBar from '@/components/custom/ActionBar'

import { mapParams } from '@/plugins/mappers'

export default {
    name: 'products',
    components: {
        ActionBar
    },
    data() {
        return {
            coupons: [],
            selectedx: null
        }
    },
    computed: {
        ...mapParams('product_id'),
        columns() {
            return [
                { title: 'Name', value: 'name' },
                { title: 'Price', value: 'price' },
                { title: 'Short Description', value: 'shortDescription' }
            ]
        },
        selected: {
            get() {
                return this.selectedx
            },
            set(val) {
                this.selectedx = val
                this.$router.push(`/products/${val.id}`)
            }
        }
    },
    watch: {
        // coupon_id: {
        //     handler: function (val) {
        //         if (!val) {
        //             this.selectedx = null
        //         }
        //     },
        //     immediate: true
        // }
    },
    methods: {}
}
</script>

<style scoped>
h2 {
    color: #6a6e6e;
}
::v-deep .vs-card--content {
    min-height: 40vh;
}
</style>
